import React, { Component, Fragment } from "react";
import AUX from "../../../hoc/Aux_";
import { Button } from "reactstrap";
import $ from "jquery";
import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
import "../../../assets/css/TeamStyle.css";
import _ from "lodash";
import EditLinkedPositionModal from "./EditLinkedPositionModal";

const ButtonToNavigate = ({ title, history, color, classes }) => (
  <Button
    type="button"
    onClick={() => history.push({ pathname: "/admin/positions" })}
    color={color}
    className={classes}
  >
    {title}
  </Button>
);

class LinkedPositionContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.type,

      check: true,
      uid: this.props.uid || 0,
      mockup_position_scope: 1,
      name: "",
      currentSection: 1,
      showLinkPositions: false,
      selectIsOwner: false,
      selectTeamId: 0,
      currentScope: 0,
      searchTerm: "",
      teamData: [],
      linkedTeamData: [],
      linkedPosition: [],
      selectTeamName: "",
      epShowModal: false,
      epHeading: "LinkedPositionNameModal",
      epTeamId: -1,
      epPositionName: null,
    };

    this.teamDetail = this.teamDetail.bind(this);

    this.loadLinkedTeam = this.loadLinkedTeam.bind(this);
    this.loadTeam = this.loadTeam.bind(this);
    this.resetStates = this.resetStates.bind(this);
    this.filterTheLinkedTeams = this.filterTheLinkedTeams.bind(this);
    this.epCloseModal = this.epCloseModal.bind(this);
    this.epShowModal = this.epShowModal.bind(this);
    this.saveLinkedPositionName = this.saveLinkedPositionName.bind(this);
  }
  saveLinkedPositionName(obj) {
    this.props.handleManageLinkedPositionName(obj.teamId, obj.positionName);
  }
  resetStates() {
    this.setState({
      showLinkPositions: false,
      selectIsOwner: false,
      selectTeamId: 0,
    });
  }
  loadTeam = () => {
    let handleManagedLinkedTeam = this.props.handleManagedLinkedTeam;
    let linkedPosition = this.props.linkedPosition;
    let TeamData = [];
    switch (this.state.currentScope) {
      case 1:
        TeamData =
          !_.isEmpty(this.state.teamData) &&
          !_.isEmpty(this.state.teamData.national)
            ? this.state.teamData.national
            : [];
        break;
      case 2:
        TeamData =
          !_.isEmpty(this.state.teamData) &&
          !_.isEmpty(this.state.teamData.region)
            ? this.state.teamData.region
            : [];
        break;
      case 3:
        TeamData =
          !_.isEmpty(this.state.teamData) &&
          !_.isEmpty(this.state.teamData.facility)
            ? this.state.teamData.facility
            : [];
        break;
      default:
    }
    return (
      <Fragment>
        <div id="TeamList">
          <ul className="w-100">
            {TeamData.filter((itemQ) =>
              _.toLower(itemQ.teamName).includes(
                _.toLower(this.state.searchTerm || "")
              )
            ).map((item, index) => {
              let linkedIndex = linkedPosition.findIndex(
                (x) => x.teamId == item.id
              );
              let isowner =
                linkedIndex != -1 ? linkedPosition[linkedIndex].isOwner : false;
              return (
                <li className={"px-4 border py-2 card-text w-100"}>
                  {item.teamName}{" "}
                  <i
                    data-id={item.id}
                    data-isowner={isowner}
                    data-name={item.teamName}
                    class="c-pointer fa-lg far mt-1 float-right fa-arrow-alt-circle-right"
                    onClick={(e) => {
                      if (this.state.selectTeamId == e.target.dataset.id) {
                        this.setState({
                          selectTeamId: 0,
                          selectIsOwner: false,
                          selectTeamName: "",
                          showLinkPositions: false,
                        });
                      } else {
                        this.setState({
                          selectTeamName: e.target.dataset.name,
                          selectIsOwner: e.target.dataset.isowner == "true",
                          selectTeamId: e.target.dataset.id,
                          showLinkPositions: true,
                        });
                      }

                      handleManagedLinkedTeam(e, "select");
                    }}
                  ></i>
                </li>
              );
            })}
          </ul>
        </div>
      </Fragment>
    );
  };

  loadLinkedTeam = () => {
    let handleManagedLinkedTeam = this.props.handleManagedLinkedTeam;
    let linkedPosition = this.props.linkedPosition;
    let TeamData = [];
    switch (this.state.currentScope) {
      case 1:
        TeamData =
          !_.isEmpty(this.state.linkedTeamData) &&
          !_.isEmpty(this.state.linkedTeamData.national)
            ? this.state.linkedTeamData.national
            : [];
        break;
      case 2:
        TeamData =
          !_.isEmpty(this.state.linkedTeamData) &&
          !_.isEmpty(this.state.linkedTeamData.region)
            ? this.state.linkedTeamData.region
            : [];
        break;
      case 3:
        TeamData =
          !_.isEmpty(this.state.linkedTeamData) &&
          !_.isEmpty(this.state.linkedTeamData.facility)
            ? this.state.linkedTeamData.facility
            : [];
        break;
      default:
    }
    return (
      <Fragment>
        <div id="TeamList">
          <ul className="w-100">
            {TeamData.filter((itemQ) =>
              _.toLower(itemQ.teamName).includes(
                _.toLower(this.state.searchTerm || "")
              )
            ).map((item, index) => {
              let linkedIndex = linkedPosition.findIndex(
                (x) => x.teamId == item.id
              );
              let isowner =
                linkedIndex != -1 ? linkedPosition[linkedIndex].isOwner : false;
              let isHideOnProfile =
                linkedIndex != -1
                  ? linkedPosition[linkedIndex].isHideOnProfile
                  : false;
              let positionName =
                linkedIndex != -1
                  ? linkedPosition[linkedIndex].positionName
                    ? linkedPosition[linkedIndex].positionName
                    : null
                  : false;
              return (
                <li className={"px-4 border py-2 card-text w-100"}>
                  <div>
                    {item.teamName}{" "}
                    <i
                      class="fas fa-pencil-alt cursorPointer ml-2"
                      onClick={() => {
                        this.epShowModal(item.id, positionName);
                      }}
                      title="Edit Linked Position Name"
                    ></i>
                    <button
                      onClick={(e) => {
                        this.props.handleManagedLinkedTeam(e, "delete");
                      }}
                      type="button"
                      data-id={item.id}
                      data-isowner={isowner}
                      data-name={item.teamName}
                      class="btn font-weight-bold float-right text-danger btn-sm"
                    >
                      <i
                        data-id={item.id}
                        data-isowner={isowner}
                        data-name={item.teamName}
                        class="fas fa-trash-alt"
                      ></i>
                    </button>
                  </div>
                  {positionName && (
                    <div className="small font-italic py-1 text-secondary">
                      {positionName}
                    </div>
                  )}
                  <div class="position-relative ml-4">
                    {this.props.positionMemberCount <= 1 && (
                      <>
                        <input
                          type="checkbox"
                          data-id={item.id}
                          data-isowner={isowner}
                          data-name={item.teamName}
                          onChange={async (e) => {
                            e.target.dataset.isowner = !isowner;
                            let event = _.cloneDeep(e);
                            await this.props.handleManagedLinkedTeam(
                              event,
                              "owner"
                            );
                          }}
                          className="form-check-input"
                          id={"lp-Owner-" + item.id}
                          checked={isowner}
                        />
                        <label
                          className="form-check-label small mr-5 font-italic text-secondary"
                          for={"lp-Owner-" + item.id}
                        >
                          As Owner
                        </label>
                      </>
                    )}
                    <input
                      type="checkbox"
                      data-id={item.id}
                      data-isowner={isowner}
                      data-ishideonprofile={isHideOnProfile}
                      data-name={item.teamName}
                      onChange={async (e) => {
                        e.target.dataset.ishideonprofile = !isHideOnProfile;
                        let event = _.cloneDeep(e);
                        await this.props.handleManagedLinkedTeam(
                          event,
                          "ishideonprofile"
                        );
                      }}
                      className="form-check-input"
                      id={"lp-IsHide-" + item.id}
                      checked={isHideOnProfile}
                    />
                    <label
                      className="form-check-label small font-italic text-secondary"
                      for={"lp-IsHide-" + item.id}
                    >
                      Hide on User’s Profile
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </Fragment>
    );
  };
  filterTheLinkedTeams(updateProps) {
    if (
      updateProps.linkedPosition != null &&
      !_.isEmpty(updateProps.linkedPosition)
    ) {
      // Step 1: Extract team IDs from linkedPosition
      const linkedTeamIds = new Set(
        updateProps.linkedPosition.map((item) => item.teamId)
      );

      // Step 2: Create filtered model with only teams in linkedPosition
      const filteredTeamData = {
        facility:
          !_.isEmpty(updateProps.teamData.facility) &&
          updateProps.teamData.facility.filter((team) =>
            linkedTeamIds.has(team.id)
          ),
        national:
          !_.isEmpty(updateProps.teamData.national) &&
          updateProps.teamData.national.filter((team) =>
            linkedTeamIds.has(team.id)
          ),
        region:
          !_.isEmpty(updateProps.teamData.region) &&
          updateProps.teamData.region.filter((team) =>
            linkedTeamIds.has(team.id)
          ),
      };

      // Step 3: Remove teams from teamData that exist in linkedPosition
      const updatedTeamData = {
        facility:
          !_.isEmpty(updateProps.teamData.facility) &&
          updateProps.teamData.facility.filter(
            (team) => !linkedTeamIds.has(team.id)
          ),
        national:
          !_.isEmpty(updateProps.teamData.national) &&
          updateProps.teamData.national.filter(
            (team) => !linkedTeamIds.has(team.id)
          ),
        region:
          !_.isEmpty(updateProps.teamData.region) &&
          updateProps.teamData.region.filter(
            (team) => !linkedTeamIds.has(team.id)
          ),
      };
      this.setState({
        teamData: updatedTeamData,
        linkedTeamData: filteredTeamData,
        linkedPosition: _.cloneDeep(updateProps.linkedPosition),
      });
    } else {
      this.setState({
        teamData: updateProps.teamData,
        linkedTeamData: [],
        linkedPosition: [],
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.state.linkedPosition) !==
      JSON.stringify(prevProps.linkedPosition)
    ) {
      this.filterTheLinkedTeams(this.props);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.linkedPosition) !==
        JSON.stringify(nextProps.linkedPosition) ||
      this.props.positionName != nextProps.positionName
    ) {
      this.resetStates();
      this.filterTheLinkedTeams(nextProps);
    }
    if (nextProps.teamData) {
      if (
        JSON.stringify(this.props.teamData) !==
        JSON.stringify(nextProps.teamData)
      ) {
        if (
          !_.isEmpty(nextProps.teamData) &&
          !_.isEmpty(nextProps.teamData.national)
        ) {
          this.state.currentScope = 1;
        } else if (
          !_.isEmpty(nextProps.teamData) &&
          !_.isEmpty(nextProps.teamData.region)
        ) {
          this.state.currentScope = 2;
        } else if (
          !_.isEmpty(nextProps.teamData) &&
          !_.isEmpty(nextProps.teamData.facility)
        ) {
          this.state.currentScope = 3;
        }
        this.setState({ currentScope: this.state.currentScope });
      }
    }
  }
  epCloseModal() {
    this.setState({ epShowModal: false });
  }
  async epShowModal(teamId, positionName) {
    await this.setState({
      epPositionName: positionName ? positionName : this.props.positionName,
      epShowModal: true,
      epTeamId: teamId,
    });
    //window.$("#" + this.state.epHeading).modal({
    //    backdrop: "static",
    //    keyboard: true,
    //    show: true,
    //});
    //window
    //    .$("#" + this.state.epHeading)
    //    .on("hidden.bs.modal", function () {
    //        if (!$("body").hasClass("modal-open")) {
    //            $("body").addClass("modal-open");
    //        }
    //    });
  }
  componentDidMount() {
    if (this.props.teamData) {
      if (
        !_.isEmpty(this.props.teamData) &&
        !_.isEmpty(this.props.teamData.national)
      ) {
        this.state.currentScope = 1;
      } else if (
        !_.isEmpty(this.props.teamData) &&
        !_.isEmpty(this.props.teamData.region)
      ) {
        this.state.currentScope = 2;
      } else if (
        !_.isEmpty(this.props.teamData) &&
        !_.isEmpty(this.props.teamData.facility)
      ) {
        this.state.currentScope = 3;
      }
      this.setState({ currentScope: this.state.currentScope });
    }
    this.filterTheLinkedTeams(this.props);
  }
  teamDetail = () => {
    let { teamData } = this.props;
    return (
      <Fragment>
        <div className="row align-items-center">
          <div className="col-lg-7 text-center">
            <form role="search" className="app-search mb-3">
              <div className="form-group mb-0">
                <input
                  type="text"
                  id="keyword"
                  className="form-control rounded border mb-1 py-2 w-100"
                  placeholder="Team Search.."
                  onChange={(e) => {
                    this.setState({ searchTerm: e.target.value });
                  }}
                />
                <button
                  onClick={(e) => {
                    this.setState({ searchTerm: $("#keyword").val() });
                  }}
                  className="c-pointer text-secondary bg-transparent border-0"
                >
                  <i className="fa fa-search" />
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          <div id="teamList" className="col-lg-6">
            <h6>Available Teams</h6>
            {this.loadTeam()}
          </div>
          <div id="linkedPosition" className="mt-3 mt-lg-0 col-lg-6">
            <h6>Linked Teams</h6>
            {this.loadLinkedTeam()}
          </div>
        </div>
      </Fragment>
    );
  };
  linkedPositionWidget() {
    let show =
      this.props.linkedPosition.findIndex(
        (x) => x.teamId == this.state.selectTeamId
      ) != -1
        ? true
        : false;
    return (
      <Fragment>
        {this.state.showLinkPositions == true && show && (
          <div className="card directory-card border-rounded shadow">
            <h5 className="card-header mt-0 px-2">Linked Position</h5>
            <div class="card-body px-2 py-0">
              <div class="row mx-0">
                <div class="col-10 py-1 row mx-0 px-0">
                  <p className="mb-0">
                    {this.props.positionName != null &&
                    this.props.positionName != ""
                      ? this.props.positionName
                      : "Name Not Assigned"}
                  </p>
                  <div className="w-100 position-relative pl-4">
                    {this.props.positionMemberCount <= 1 ? (
                      <>
                        <input
                          type="checkbox"
                          style={{ bottom: "5px", left: "27px" }}
                          data-id={this.state.selectTeamId}
                          data-name={this.state.selectTeamName}
                          checked={this.state.selectIsOwner}
                          onChange={async (e) => {
                            e.target.dataset.isowner = !this.state
                              .selectIsOwner;
                            let event = _.cloneDeep(e);
                            await this.setState({
                              selectIsOwner: !this.state.selectIsOwner,
                            });
                            await this.props.handleManagedLinkedTeam(
                              event,
                              "owner"
                            );
                          }}
                          data-isowner={this.state.selectIsOwner}
                          className="form-check-input"
                          id="lp-Owner"
                        />
                        <label
                          className="form-check-label font-italic text-secondary"
                          for="lp-Owner"
                        >
                          As Owner
                        </label>
                      </>
                    ) : (
                      <>
                        <input
                          type="checkbox"
                          style={{ left: "27px" }}
                          className="form-check-input"
                          id="lp-Owner"
                          disabled={true}
                        />
                        <label
                          className="form-check-label font-italic text-secondary"
                          for="lp-Owner"
                        >
                          Owner is disabled because position have more than one
                          member.
                        </label>
                      </>
                    )}
                  </div>
                </div>
                <div class="col-2 px-0 pb-sm-1 align-self-center">
                  <div>
                    <button
                      onClick={(e) => {
                        this.props.handleManagedLinkedTeam(e, "delete");
                        let linkedIndex = this.props.linkedPosition.findIndex(
                          (x) => x.teamId == this.state.selectTeamId
                        );
                        if (linkedIndex == -1) {
                          this.setState({
                            showLinkPositions: false,
                            selectTeamId: 0,
                            selectTeamName: "",
                          });
                        }
                      }}
                      type="button"
                      data-id={this.state.selectTeamId}
                      data-isowner={this.state.selectIsOwner}
                      data-name={this.state.selectTeamName}
                      class="btn font-weight-bold text-danger btn-sm"
                    >
                      <i
                        data-id={this.state.selectTeamId}
                        data-name={this.state.selectTeamName}
                        class="fas fa-trash-alt"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }

  render() {
    return (
      <AUX>
        <div>
          <div className="row">
            <div className="col-12">
              Click a team from the available list to link this position to it.
              The selected team will appear in the linked teams section, and any
              modifications to the position will be reflected on all linked
              teams.
            </div>
            <div className="col-12 mb-2">
              <h5 className="text-primary font-italic font-weight-bold">
                Currently Linking...
              </h5>
              <h3 className="font-style-italic">{this.props.positionName}</h3>
              {this.props.positionMemberCount > 1 && (
                <p className="text-italic">
                  Note: This position cannot be linked as Owner because it has
                  more than one member.
                </p>
              )}
            </div>
          </div>
          {this.props.teamData && (
            <div className="row">
              <div className="col-12">
                {!_.isEmpty(this.props.teamData) &&
                  !_.isEmpty(this.props.teamData.national) && (
                    <button
                      className={
                        "btn btn-md text-white mr-2 rounded-pill" +
                        (this.state.currentScope == 1
                          ? " btn-success"
                          : " btn-info")
                      }
                      onClick={(e) => {
                        this.setState({ currentScope: 1 });
                      }}
                    >
                      <i className="mr-2 fas fa-globe" /> National
                    </button>
                  )}
                {!_.isEmpty(this.props.teamData) &&
                  !_.isEmpty(this.props.teamData.region) && (
                    <button
                      className={
                        "btn btn-md text-white mr-2 rounded-pill" +
                        (this.state.currentScope == 2
                          ? " btn-success"
                          : " btn-info")
                      }
                      onClick={(e) => {
                        this.setState({ currentScope: 2 });
                      }}
                    >
                      <i className="mr-2 fas fa-server" />
                      Region
                    </button>
                  )}
                {!_.isEmpty(this.props.teamData) &&
                  !_.isEmpty(this.props.teamData.facility) && (
                    <button
                      className={
                        "btn btn-md text-white mr-2 rounded-pill" +
                        (this.state.currentScope == 3
                          ? " btn-success"
                          : " btn-info")
                      }
                      onClick={(e) => {
                        this.setState({ currentScope: 3 });
                      }}
                    >
                      <i className="mr-2 fas fa-university" />
                      Facility
                    </button>
                  )}
              </div>
              <div className="col-lg-8"></div>
            </div>
          )}
          {this.teamDetail()}
        </div>
        <EditLinkedPositionModal
          teamId={this.state.epTeamId}
          positionName={this.state.epPositionName}
          heading={this.state.epHeading}
          openModal={this.state.epShowModal}
          closeModal={this.epCloseModal}
          saveLinkedPositionName={this.saveLinkedPositionName}
        />
      </AUX>
    );
  }
}

export default LinkedPositionContent;
